"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../utils/constants");
var muiFacebook24 = {
    paths: [
        {
            path: 'M22.2219581,0.0094741573 L1.76884195,0.0094741573 C1.06798801,0.0094741573 0.499965543,0.602193258 0.499965543,1.3335191 L0.499965543,22.6759011 C0.499965543,23.4071371 1.06798801,24.000036 1.76884195,24.000036 L12.7801566,24.000036 L12.7801566,14.709609 L9.78395431,14.709609 L9.78395431,11.0889348 L12.7801566,11.0889348 L12.7801566,8.41882247 C12.7801566,5.32021573 14.593797,3.63293483 17.2428457,3.63293483 C18.5118082,3.63293483 19.60237,3.73145169 19.9201491,3.77549663 L19.9201491,7.01378876 L18.0829056,7.01468764 C16.6422614,7.01468764 16.3632464,7.72902472 16.3632464,8.77729438 L16.3632464,11.0889348 L19.7992052,11.0889348 L19.3518682,14.709609 L16.3632464,14.709609 L16.3632464,24.000036 L22.2219581,24.000036 C22.9227258,24.000036 23.4909206,23.4071371 23.4909206,22.6759011 L23.4909206,1.3335191 C23.4909206,0.602193258 22.9227258,0.0094741573 22.2219581,0.0094741573',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Facebook',
    width: 24,
    height: 24,
};
var muiFacebook = {
    base: muiFacebook24,
    lgIcon: muiFacebook24,
};
exports.muiFacebook = muiFacebook;
//# sourceMappingURL=facebook.js.map